import { render, staticRenderFns } from "./pnrDetailTable.vue?vue&type=template&id=2298179c&scoped=true&"
import script from "./pnrDetailTable.vue?vue&type=script&lang=js&"
export * from "./pnrDetailTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2298179c",
  null
  
)

export default component.exports